export var callIfDefined = function callIfDefined(func) {
  if (func) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    func.apply(void 0, args);
  }
};
export var canPublish = function canPublish() {
  return typeof window !== "undefined" && window.PubSub;
};
export var safePublish = function safePublish() {
  if (canPublish()) {
    var _window$PubSub;

    (_window$PubSub = window.PubSub).publish.apply(_window$PubSub, arguments);
  }
};